var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 10.6667L1.81818 12.4444L3.63636 12.4444L3.63636 10.6667L1.81818 10.6667ZM12.7273 14.2222L12.7273 16L14.5455 16L14.5455 14.2222L12.7273 14.2222ZM16.3636 -1.58951e-07L3.63636 -7.15277e-07C2.63636 -7.58989e-07 1.81818 0.799999 1.81818 1.77778L1.81818 5.33333L3.63636 5.33333L3.63636 1.77778L16.3636 1.77778L16.3636 5.33333L18.1818 5.33333L18.1818 1.77778C18.1818 0.8 17.3636 -1.15239e-07 16.3636 -1.58951e-07ZM18.1818 14.2222L16.3636 14.2222L16.3636 16C17.3636 16 18.1818 15.2 18.1818 14.2222ZM-3.10837e-07 7.11111L-3.88546e-07 8.88889L20 8.88889L20 7.11111L-3.10837e-07 7.11111ZM5.45454 14.2222L5.45454 16L7.27273 16L7.27273 14.2222L5.45454 14.2222ZM16.3636 10.6667L16.3636 12.4444L18.1818 12.4444L18.1818 10.6667L16.3636 10.6667ZM9.09091 14.2222L9.09091 16L10.9091 16L10.9091 14.2222L9.09091 14.2222ZM1.81818 14.2222C1.81818 15.2 2.63636 16 3.63636 16L3.63636 14.2222L1.81818 14.2222Z",
    fill: "#0096D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.f60e692f9f808ef2d958ee9ae86333b3.svg";
export { ForwardRef as ReactComponent };